// ─── Shared merge-tag interpolation (frontend) ─────────────────────────────
// Mirrors mergeTags.js on the backend exactly (same resolvers, same
// conditional-block syntax) so live previews in MailMerge.js and
// SequenceBuilder.js render identically to what the server actually sends.
// See the backend copy for the full design-rationale comment.

export const MERGE_TAG_PATTERN = /\{\{\s*([A-Za-z0-9_]+)\s*\}\}/g;
export const CONDITIONAL_BLOCK_PATTERN = /\[\[IF:([^=\]]+)=([^\]]+)\]\]([\s\S]*?)(?:\[\[ELSE\]\]([\s\S]*?))?\[\[ENDIF\]\]/g;

const BUILTIN_RESOLVERS = {
  FirstName: (c) => c.firstName || c.first || (c.name ? String(c.name).split(" ")[0] : "") || "",
  LastName:  (c) => c.lastName || c.last || (c.name ? String(c.name).split(" ").slice(1).join(" ") : "") || "",
  Title:     (c) => c.title || "",
  Company:   (c) => c.company || "",
  CompanyNameForEmails: (c) => String(c.company || "").replace(/[^a-zA-Z0-9]/g, ""),
  Email:     (c) => c.email || "",
  SenderName:    (c, sender) => (sender && (sender.sdrName || sender.name)) || "",
  SenderCompany: (c, sender) => (sender && sender.company) || "",
};

function lookupCaseInsensitive(obj, key) {
  if (!obj || typeof obj !== "object") return undefined;
  if (obj[key] != null) return obj[key];
  const lower = key.toLowerCase();
  const found = Object.keys(obj).find((k) => k.toLowerCase() === lower);
  return found ? obj[found] : undefined;
}

export function interpolateMergeTags(text, contact = {}, sender = {}, customFields = {}) {
  if (!text) return text || "";
  return String(text).replace(MERGE_TAG_PATTERN, (match, tagName) => {
    if (BUILTIN_RESOLVERS[tagName]) {
      const val = BUILTIN_RESOLVERS[tagName](contact, sender);
      return val == null ? "" : String(val);
    }
    const fromContactCustom = lookupCaseInsensitive(contact.customFields, tagName);
    if (fromContactCustom != null) return String(fromContactCustom);
    const fromCustomFields = lookupCaseInsensitive(customFields, tagName);
    if (fromCustomFields != null) return String(fromCustomFields);
    const fromContact = lookupCaseInsensitive(contact, tagName);
    if (fromContact != null) return String(fromContact);
    return match;
  });
}

export function applyConditionalBlocks(text, contact = {}) {
  if (!text) return text || "";
  return String(text).replace(CONDITIONAL_BLOCK_PATTERN, (match, field, value, ifBlock, elseBlock) => {
    const fieldVal = String(lookupCaseInsensitive(contact, field.trim()) ?? "").trim().toLowerCase();
    const target = value.trim().toLowerCase();
    return fieldVal === target ? (ifBlock || "").trim() : (elseBlock || "").trim();
  });
}

export function renderBody(text, contact = {}, sender = {}, customFields = {}) {
  return interpolateMergeTags(applyConditionalBlocks(text, contact), contact, sender, customFields);
}

export function renderSubject(text, contact = {}, sender = {}, customFields = {}) {
  return interpolateMergeTags(text, contact, sender, customFields);
}
